import { MouseEventHandler } from 'react'
import { Menu } from '@headlessui/react'
import { classes } from 'src/utils'

type Props = {
  label: string
  icon: (props: React.ComponentProps<'svg'>) => JSX.Element
  onClick: MouseEventHandler
}

export default function LoginButtonMenuItem(props: Props) {
  const Icon = props.icon
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          onClick={props.onClick}
          className={classes(
            active ? 'bg-theme-500 text-white' : 'text-gray-900',
            'group flex w-full items-center rounded-md px-2 py-2 text-sm',
          )}
        >
          <Icon
            className={classes('mr-2 h-5 w-5', !active && 'fill-theme-500')}
            aria-hidden="true"
          />
          {props.label}
        </button>
      )}
    </Menu.Item>
  )
}
